module.exports = __webpack_public_path__ + "static/media/CroppedColumnReversed.38c7f2cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprites/CroppedColumnReversed.png
// module id = 298
// module chunks = 0